import React, { useId, useMemo, useState } from "react";
import "./Dropzone.css";

export default function Dropzone({
  acceptText = "Déposez vos fichiers ici",
  helperText = "Glissez-déposez ou cliquez sur “Choisir”",
  accept = "",
  multiple = false,
  disabled = false,
  onFiles, // (File[]) => void
}) {
  const [isOver, setIsOver] = useState(false);
  const inputId = useId();

  const inputAccept = useMemo(() => accept, [accept]);

  const takeFiles = (list) => {
    const files = Array.from(list || []);
    onFiles?.(multiple ? files : files.slice(0, 1));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setIsOver(false);
    takeFiles(e.dataTransfer?.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (disabled) return;
    setIsOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOver(false);
  };

  const handlePick = (e) => {
    if (disabled) return;
    takeFiles(e.target.files);
    e.target.value = "";
  };

  const openPicker = () => {
    if (disabled) return;
    document.getElementById(inputId)?.click();
  };

  return (
    <div
      className={`dropzone ${isOver ? "is-over" : ""} ${
        disabled ? "is-disabled" : ""
      }`}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      role="region"
      aria-disabled={disabled}
    >
      <div className="dropzone-title">{acceptText}</div>
      <div className="dropzone-helper">{helperText}</div>

      <div className="dropzone-actions">
        <button
          type="button"
          className="dropzone-btn"
          onClick={openPicker}
          disabled={disabled}
        >
          Choisir un fichier
        </button>
      </div>

      <input
        id={inputId}
        className="dropzone-input"
        style={{ display: "none" }}
        type="file"
        accept={inputAccept}
        multiple={multiple}
        disabled={disabled}
        onChange={handlePick}
      />
    </div>
  );
}
